import { StringKey } from '../lang/index';
import { getTranslation } from './get-translation.util';

export const formatBytesPrecise = (bytes: number): string => {
  if (!Number(bytes)) return '0';

  const k = 1024;
  const sizes = ['SIZE_B', 'SIZE_KB', 'SIZE_MB', 'SIZE_GB'] as unknown as StringKey[];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = bytes / Math.pow(k, i);
  const decimals = i === 0 ? 0 : 1;

  return `${parseFloat(value.toFixed(decimals))} ${getTranslation(sizes[i])}`;
};
